import { render, staticRenderFns } from "./OperatorsQualityProjects.vue?vue&type=template&id=97352866&scoped=true&"
import script from "./OperatorsQualityProjects.vue?vue&type=script&lang=js&"
export * from "./OperatorsQualityProjects.vue?vue&type=script&lang=js&"
import style0 from "./OperatorsQualityProjects.vue?vue&type=style&index=0&id=97352866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97352866",
  null
  
)

export default component.exports